class Range {
  public static to = (to: number): number[] => Array.from(Array(to).keys())
}

export default Range
